"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var BASE_CLASS = 'csc-reset-password';
var LinkExpired = function LinkExpired(expired) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-wrapper form-wrapper--has-shadow ".concat(BASE_CLASS)
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "text-center"
  }, expired.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 text-center ".concat(BASE_CLASS, "__intro")
  }, /*#__PURE__*/_react.default.createElement("p", null, expired.subtitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 text-center ".concat(BASE_CLASS, "__sub")
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(BASE_CLASS, "__button_wrapper")
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    id: "".concat(BASE_CLASS, "__button"),
    qaId: "".concat(BASE_CLASS, "__button"),
    name: "".concat(BASE_CLASS, "__button"),
    type: "submit",
    version: expired.button.version,
    onClick: function onClick() {
      return location.replace(expired.button.redirectUrl);
    }
  }, expired.button.label)))));
};
LinkExpired.propTypes = {
  expired: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    button: _propTypes.default.shape({
      label: _propTypes.default.string,
      version: _propTypes.default.string,
      redirectUrl: _propTypes.default.string
    })
  })
};
var _default = exports.default = LinkExpired;